import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Input } from 'controls'
import classnames from 'classnames'
import { Row, Col } from 'flexbox'
import styles, { slick } from './styles'
import SwipeableViews from 'react-swipeable-views'

class Wizard extends Component {
  static propTypes = {
    hide: PropTypes.bool.isRequired,
    currentPage: PropTypes.number.isRequired,
    slideClassName: PropTypes.string,
    nextButtonEnabled: PropTypes.bool.isRequired,
    nextPage: PropTypes.func.isRequired,
    previousPage: PropTypes.func.isRequired
  }

  static defaultProps = {
    currentPage: 0,
    pageChanged: () => {},
    pageWillChange: () => {}
  }

  render() {
    const {
      hide,
      handleSubmit,
      children,
      nextButtonEnabled,
      slideContainerClassName,
      pageWillChange,
      pageChanged,
      nextPage,
      previousPage
    } = this.props

    const hideStyle = hide ? { display: 'none' } : {}

    return (
      <form onSubmit={handleSubmit} style={{ ...hideStyle }}>
        <SwipeableViews
          index={this.props.currentPage}
          disabled
        >
          {React.Children.map(children, (c, i) => (
            <div
              key={i}
              className={classnames('slide-container', slideContainerClassName)}
            >
              <div className="slide-content">{c}</div>
            </div>
          ))}
        </SwipeableViews>

        {(previousPage || nextPage) && (
          <div className="buttons-container">
            <Row>
              {previousPage && (
                <Col xs={6} sm={4} smOffset={2}>
                  <Button
                    color="primary"
                    fullWidth
                    outline
                    onClick={previousPage}
                  >
                    Anterior
                  </Button>
                </Col>
              )}
              {nextPage && (
                <Col xs={6} sm={4}>
                  <Button
                    color="primary"
                    fullWidth
                    onClick={nextPage}
                    disabled={!nextButtonEnabled}
                  >
                    Siguiente
                  </Button>
                </Col>
              )}
            </Row>
          </div>
        )}
        <style jsx>{styles}</style>
        <style jsx global>
          {slick}
        </style>
      </form>
    )
  }
}

export default Wizard
